import PropTypes from 'prop-types';
import { MenuItem, Radio, makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../../../../textBoxWithTooltip';
import TagHash from '../../../../tagHash';
import ColorBox from '../../../../colorBox';
import CustomCheckbox from '../../../../customCheckbox';
import { isArrayEmpty } from '../../../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    padding: spacing(2, 1, 2, 2),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: primary.bluish8,
    },
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  label: {
    cursor: 'pointer',
    display: 'block',
    maxWidth: '100%',
    flexGrow: 1,
  },
  iconWrapper: {
    display: 'flex',
    flexShrink: 0,
    marginRight: spacing(2),
  },
  adornment: {
    flexShrink: 0,
    marginRight: spacing(2),
  },
  radioButton: {
    color: primary.bluish4,
    flexShrink: 0,
    width: 24,
    height: 24,
    marginLeft: spacing(1.5),
  },
  radioChecked: {
    color: `${primary.bluish4} !important`,
  },
  checkbox: {
    marginLeft: spacing(1.5),
  },
  icon: {
    maxWidth: 16,
    maxHeight: 16,
  },
}));

const SubMenuItem = ({
  item,
  isSelected = false,
  isSingleSelect = false,
  hasHash = false,
  hasColorBox = false,
  selectedFilters,
  onSelect,
}) => {
  const classes = useStyles();
  const { id, name, icon: Icon, color, category, label } = item;

  return (
    <MenuItem
      id={`sub-menu-item-${id}`}
      classes={{
        root: classes.root,
      }}
      onClick={onSelect(id)}
    >
      <span className={classes.contentWrapper}>
        {Icon && (
          <span className={classes.iconWrapper}>
            <Icon className={classes.icon} />
          </span>
        )}
        {hasHash && (
          <TagHash
            className={classes.adornment}
            bgColor={color || category?.color}
          />
        )}
        {hasColorBox && (
          <ColorBox className={classes.adornment} bgColor={color} isSmall />
        )}
        <TextBoxWithTooltip
          className={classes.label}
          component="span"
          text={label || name}
        />
        {isSingleSelect ? (
          <Radio
            classes={{
              root: classes.radioButton,
              checked: classes.radioChecked,
            }}
            checked={
              isSelected || (isArrayEmpty(selectedFilters) && id === null)
            }
            onChange={onSelect(id)}
          />
        ) : (
          <CustomCheckbox
            customRootClass={classes.checkbox}
            isChecked={isSelected}
            onChange={onSelect(id)}
            isControlled
          />
        )}
      </span>
    </MenuItem>
  );
};

SubMenuItem.propTypes = {
  item: PropTypes.object.isRequired,
  selectedFilters: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ).isRequired,
  isSelected: PropTypes.bool,
  isSingleSelect: PropTypes.bool,
  hasHash: PropTypes.bool,
  hasColorBox: PropTypes.bool,
};

export default SubMenuItem;
